import type { Model } from '@patsnap/tahiti-core';
import type { SpecificationState } from '../types/specification';

export const SpecificationModel = Symbol.for('SpecificationModel');

export interface SpecificationModel extends Model<SpecificationState> {}
